import { BaseProduct } from "Store/interfaces/products/checkPrice/BaseProduct";

export enum BoatInsuranceType {
  BOAT_SUPER = "boatSuper",
  BOAT_FULL_OWN_DAMAGE = "boatKasko",
  BOAT_REDUCED_OWN_DAMAGE = "boatDelkasko",
}

export interface BoatPriceRequestInfo extends BaseProduct {
  boatType?: string;
  brandAndModel?: string;

  engineBrand?: string;
  engineHorsePower?: number;
  engineTopSpeed?: number;

  lengthInFeet?: number;
  modelYear?: number;

  harbourZipCode?: string;

  hullAndEngineIdMarked: boolean;
  memberOfRedningsselskapetCoastGuard: boolean;
  usedByYoungerDriver: boolean;
  harbourSecurity: boolean;
  trackingSystem: boolean;
  boatNotPristine?: boolean;

  damageCountRecentYears?: number;
  coverageAmount?: number;

  numberOfYearsAsOwner?: number;
  injuries?: number;
  injuryYear?: number;
}
